import React from 'react';
import { motion } from 'framer-motion';

const ScrollArrow = ({ sectionId }) => {
  const handleClick = () => {
    const sections = document.querySelectorAll('section[id]');
    const currentSection = document.getElementById(sectionId);

    if (!currentSection) return;

    let foundCurrent = false;
    for (let i = 0; i < sections.length; i++) {
      if (sections[i] === currentSection) {
        foundCurrent = true;
        continue;
      }
      if (foundCurrent) {
        const targetSection = sections[i];
        const startPosition = window.pageYOffset;
        const targetPosition = targetSection.getBoundingClientRect().top + window.pageYOffset;
        const distance = targetPosition - startPosition;
        const duration = 1200;
        let startTime = null;

        const easeInOutCubic = (t) => {
          return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
        };

        const animateScroll = (currentTime) => {
          if (startTime === null) startTime = currentTime;
          const timeElapsed = currentTime - startTime;
          const progress = Math.min(timeElapsed / duration, 1);
          const easedProgress = easeInOutCubic(progress);

          window.scrollTo(0, startPosition + distance * easedProgress);

          if (progress < 1) {
            requestAnimationFrame(animateScroll);
          }
        };

        requestAnimationFrame(animateScroll);
        break;
      }
    }
  };

  return (
    <div className="section-scroll-indicator" onClick={handleClick}>
      <motion.div
        animate={{ y: [0, 10, 0] }}
        transition={{ duration: 1.5, repeat: Infinity }}
        className="scroll-arrow"
      >
        ↓
      </motion.div>
    </div>
  );
};

export default ScrollArrow;

